import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import RequestCardSkeletonMobileList from "./RequestCardSkeletonMobile";

const PrintRequestsSkeletonMobile = () => {
  return (
    <Stack sx={{ px: 1, pb: 8 }}> {/* ✅ Removed pt: 5 */}
      {/* Search/Filter Input Skeleton */}
      <Box sx={{ mb: 2 }}>
        <Skeleton 
          variant="rounded" 
          width="100%" 
          height={38} 
          sx={{ borderRadius: 2 }} 
        />
      </Box>

      {/* Tab Skeleton */}
      <Box 
        sx={{ 
          display: "flex", 
          gap: 2, 
          mb: 2, 
          overflowX: "auto",
          pb: 1,
        }}
      >
        {[...Array(4)].map((_, i) => (
          <Skeleton 
            key={i}
            variant=  "rounded" 
            width={90} 
            height={25} 
            sx={{ borderRadius: 2, flexShrink: 0 }} 
          />
        ))}
      </Box>

      {/* Request Card Skeletons */}
      <RequestCardSkeletonMobileList rows={5} isHistory={false} />
    </Stack>
  );
};

export default PrintRequestsSkeletonMobile;
